import { ClientStub } from "#@/rpcSystem/stubs/clientStub";

export abstract class AnonClientStub extends ClientStub {
    public initialStubName(): string {
        return "";
    }
}